import { z } from "zod";

/**
 * PRTL-1349: one generated size of an uploaded raster image. Variants are
 * WebP at fixed widths, written next to the original in the uploads bucket
 * (`<original key>_w<width>.webp`) and served through the CDN.
 */
export const ImageVariantSchema = z.object({
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    url: z.string(),
    format: z.literal("webp"),
});
export type ImageVariant = z.infer<typeof ImageVariantSchema>;

/** What `File.variants` / `AdminAsset.variants` hold (JSON column). */
export const ImageVariantListSchema = z.array(ImageVariantSchema);

/**
 * A displayable image. `src` is always usable on its own (the original);
 * `srcSet`, `width` and `height` are present once variants exist, so clients
 * can pick a size and reserve layout space.
 */
export const ImageSourceSchema = z.object({
    src: z.string(),
    srcSet: z.string().optional(),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
    variants: z.array(ImageVariantSchema).optional(),
});
export type ImageSource = z.infer<typeof ImageSourceSchema>;
